import { createModalStore } from '@/shared/lib/modal';
import { Plan, Price } from '@/shared/types/Billing';

type UpgradeConfirmationModalProps = {
  currentPlan?: Plan;
  minutesToAdd?: number;
  targetPlan?: Plan;
  targetPrice?: Price;
};

const initialState: UpgradeConfirmationModalProps = {
  currentPlan: undefined,
  minutesToAdd: undefined,
  targetPlan: undefined,
  targetPrice: undefined,
};

export const useUpgradeConfirmationModalStore = createModalStore<UpgradeConfirmationModalProps>(initialState, false);
